<template>
  <div class="card">
    <h2 class="text-xl font-heading font-semibold text-mifo-primary mb-6">Kursoptionen auswählen</h2>
    <div class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Preiskategorie *</label>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div @click="select('standard')" class="border-2 rounded-lg p-4 cursor-pointer transition-colors" :class="modelValue === 'standard' ? 'border-mifo-accent bg-mifo-accent/5' : 'border-gray-300 hover:border-gray-400'">
            <div class="flex items-center justify-between">
              <div>
                <h3 class="font-medium text-gray-900">Standard</h3>
                <p class="text-sm text-gray-500">Für alle Teilnehmer</p>
              </div>
              <div class="text-right">
                <p class="text-lg font-semibold text-mifo-primary">{{ formatCurrency(course?.prices?.standard || 0) }}</p>
              </div>
            </div>
          </div>
          <div @click="select('assistenzarzt')" class="border-2 rounded-lg p-4 cursor-pointer transition-colors" :class="modelValue === 'assistenzarzt' ? 'border-mifo-accent bg-mifo-accent/5' : 'border-gray-300 hover:border-gray-400'">
            <div class="flex items-center justify-between">
              <div>
                <h3 class="font-medium text-gray-900">Assistenzarzt</h3>
                <p class="text-sm text-gray-500">Reduzierter Preis</p>
              </div>
              <div class="text-right">
                <p class="text-lg font-semibold text-mifo-primary">{{ formatCurrency(course?.prices?.assistenzarzt || 0) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from 'shared/utils'

export default {
  name: 'PriceSelection',
  props: {
    modelValue: { type: String, default: null },
    course: { type: Object, required: true }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const select = (value) => emit('update:modelValue', value)
    return { select, formatCurrency }
  }
}
</script>

